import PropTypes from 'prop-types'

const STAGES = ['Pre-contemplation', 'Contemplation', 'Preparation', 'Action', 'Maintenance']

function ProfileSection({ profile, readiness }) {
  if (!profile) return null
  const current = readiness?.stage?.level ?? 1

  return (
    <section className="section" aria-labelledby="profile-h">
      <div className="section__head">
        <h2 id="profile-h">Behavioural profile</h2>
        <p className="section__desc">The pattern your answers most resemble, and where you sit on the stages-of-change model.</p>
      </div>

      <div className="profile">
        <div className="section" style={{ gap: 14 }}>
          <div>
            <h3>{profile.name}</h3>
            <p className="section__desc">Seen in about {profile.prevalence?.replace(' of users', '')} of people who take this.</p>
          </div>
          <dl className="kv">
            <dt>what it tends to look like</dt>
            <dd>
              <ul className="profile__list">
                {(profile.characteristics || []).map((c) => <li key={c}>{c}</li>)}
              </ul>
            </dd>
          </dl>
          <dl className="kv">
            <dt>common triggers</dt>
            <dd>{(profile.triggers || []).join(', ')}</dd>
          </dl>
          <dl className="kv">
            <dt>where work usually starts</dt>
            <dd>{profile.intervention}</dd>
          </dl>
        </div>

        <div className="section" style={{ gap: 14 }}>
          <div>
            <h3>Readiness to change</h3>
            <p className="section__desc">{readiness?.stage?.name}: {readiness?.stage?.description?.toLowerCase()}</p>
          </div>
          <ol className="stages" aria-label="Stages of change">
            {STAGES.map((s, i) => {
              const level = i + 1
              const cls = level < current ? 'is-done' : level === current ? 'is-current' : ''
              return (
                <li key={s} className={`stage ${cls}`} aria-current={level === current ? 'step' : undefined}>
                  <span className="stage__bar" />
                  <span className="stage__n">{level}</span>
                  <span className="stage__name">{s}</span>
                </li>
              )
            })}
          </ol>
          <p className="band__desc">{readiness?.recommendation}</p>
        </div>
      </div>
    </section>
  )
}

ProfileSection.propTypes = {
  profile: PropTypes.object,
  readiness: PropTypes.object,
}

export default ProfileSection
